import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 10px 0 30px;

  .icon,
  .text {
    vertical-align: middle;
    display: inline-block;
  }
`